import styled from 'styled-components';
import { P } from '@workramp/ui';
import { AutoResizingText } from './AutoResizingText';

export const StyledWrapper = styled.div`
  position: relative;
`;

export const StyledBackgroundImg = styled.img`
  width: 100%;
  vertical-align: middle;
`;

export const StyledSidebar = styled.div<{ $textColor: string }>`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  height: 100%;
  width: 261px;
  color: ${({ $textColor }) => $textColor};
  text-align: center;
`;

export const StyledBadgeImg = styled.img`
  position: absolute;
  width: ${({ theme }) => theme.spacing(25)}px;
  top: ${({ theme }) => theme.spacing(15)}px;
  left: 50%;
  transform: translateX(-50%);
`;

export const StyledSidebarCertificateTitleContainer = styled.div`
  position: absolute;
  width: 165px;
  left: 50%;
  transform: translateX(-50%);
  top: ${({ theme }) => theme.spacing(46)}px;
`;

export const StyledSidebarCertificateTitle = styled(AutoResizingText)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ theme }) => theme.spacing(16)}px;
`;

export const StyledCertificateId = styled(P)`
  position: absolute;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
  top: ${({ theme }) => theme.spacing(73)}px;
`;

export const StyledLogo = styled.img`
  position: absolute;
  max-width: ${({ theme }) => theme.spacing(30)}px;
  max-height: ${({ theme }) => theme.spacing(10)}px;
  left: 50%;
  transform: translateX(-50%);
  bottom: 50px;
`;

export const StyledMain = styled.div<{ $textColor: string }>`
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  width: calc(100% - 261px);
  height: 100%;
  color: ${({ $textColor }) => $textColor};
`;

export const StyledMainContent = styled.div`
  padding-left: ${({ theme }) => theme.spacing(16)}px;
  padding-right: ${({ theme }) => theme.spacing(16)}px;
`;

export const StyledLearnerNameContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing(15)}px;
`;

export const StyledLearnerName = styled(AutoResizingText)`
  max-width: 95%;
`;

export const StyledCompletedMsg = styled(P)`
  margin-top: 49px;
`;

export const StyledMainCertificateTitle = styled.div`
  margin-top: ${({ theme }) => theme.spacing(4)}px;
`;

export const StyledAwardedAtDate = styled(P)`
  margin-top: ${({ theme }) => theme.spacing(4)}px;
`;

export const StyledCertificateDescription = styled(P)`
  margin-top: ${({ theme }) => theme.spacing(8)}px;
`;

export const StyledCertFooterContainer = styled.div`
  position: absolute;
  bottom: ${({ theme }) => theme.spacing(19)}px;
  width: calc(100% - 128px);
  left: 50%;
  transform: translateX(-50%);
`;
